
import { OrphanPreview } from "@/api/orphanSubcollections";
import MBaseModal from "@/components/MBaseModal.vue";
import MButton from "@/components/MButton.vue";
import { Options, Vue } from "vue-class-component";

export type BulkOutcome = {
  deleted: { path: string; count: number }[];
  refused: { path: string; reason: string }[];
  errors: { path: string; message: string }[];
};

@Options({
  components: { MBaseModal, MButton },
  props: {
    stage: { type: String, required: true },
    progress: { type: Object, required: true },
    deletable: { type: Array, default: () => [] },
    excluded: { type: Array, default: () => [] },
    outcome: { type: Object, required: true }
  },
  emits: ["close", "execute"]
})
export default class OrphanBulkDeletionModal extends Vue {
  stage!: "checking" | "confirm" | "running" | "done";
  progress!: { done: number; total: number };
  deletable!: OrphanPreview[];
  excluded!: { path: string; reason: string }[];
  outcome!: BulkOutcome;

  get busy(): boolean {
    return this.stage === "checking" || this.stage === "running";
  }
  get totalDocs(): number {
    return this.deletable.reduce((sum, p) => sum + p.docCount, 0);
  }
  get movedCount(): number {
    return this.deletable.filter(p => p.category === "moved_leftover").length;
  }
  get ownerlessCount(): number {
    return this.deletable.filter(p => p.category === "ownerless").length;
  }
  get deletedDocs(): number {
    return this.outcome.deleted.reduce((sum, d) => sum + d.count, 0);
  }

  // 取り消せない削除なので、実行の前に、件数を示して、もう一度確認する
  confirmAndExecute() {
    if (this.busy || this.deletable.length === 0) return;
    const ok = window.confirm(
      `${this.deletable.length} 件（計 ${this.totalDocs} 件の文書）を削除します。この操作は取り消せません。よろしいですか？`
    );
    if (ok) this.$emit("execute");
  }
}
